<template>
  <div
    class="my-2"
  >

    <!-- flash message -->
    <adivare-flashes
      :show-all-subjects-except="['cancellation-review']"
      scroll-to-flash
      class="mb-2"
    />
    <div :class="[
      'flex gap-4',
      null === getActiveCancellation ? 'flex-col w-full max-w-xl m-auto mt-2' : 'flex-col items-start lg:flex-row md:pt-6 md:pb-8',
      {'md:gap-12 mt-4' : null === getActiveCancellation && true === isGuaranteed}
    ]">

      <!-- form -->
      <div
        class="box-theme box-theme--shadow-against-white-background box-theme--border-against-white-background w-full overflow-hidden flex-1"
      >

        <!-- step 1 -->
        <adivare-letter-form :loading="loading" />
        <template v-if="null !== getActiveCancellation">

          <!-- divider image -->
          <img
            :src="$asset('img/common/triangles/triangle-down-form-1.svg')"
            alt=""
            loading="lazy"
            class="w-full h-8 bg-form-grey-lighter"
          />

          <!-- step 2 -->
          <adivare-letter-prices
            ref="prices"
            :cloudflare-turnstile-site-key="cloudflareTurnstileSiteKey" />
        </template>
        <ul
          aria-live="polite"
          class="sr-only"
          :aria-label="screenReaderErrorFieldList.length > 0 ?
            $t('messages_nl.label.cancellation.userLetter.ariaError') : ''"
        >
          <li v-for="error in screenReaderErrorFieldList" :key="error.index">
            {{ error }}
          </li>
        </ul>
      </div>

      <!-- preview letter -->
      <div
        class="flex-1"
      >
        <adivare-letter-preview/>

        <div class="flex flex-col md:flex-row items-center relative my-2 justify-between">

          <!-- social widgets -->
          <adivare-share-widget
            :twitter-handle="twitterHandle"
            size="sm"
          />

          <!-- pdf download button -->
          <adivare-letter-download
            :download-url="pdfDownloadUrl"
            class="md:text-right mt-3 md:my-0"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdivareFlashes from "../ui/flashes.vue";
import AdivareLetterForm from "./letter-form.vue";
import AdivareLetterPreview from "./letter-preview.vue";
import AdivareLetterPrices from "./letter-prices.vue";
import AdivareLetterDownload from "./letter-download.vue";
import AdivareShareWidget from "../share-widget.vue";
import { AdivareSpinner } from '@adivare/vue-components';
import { mapGetters } from 'vuex';

export default {
  name: "adivare-letter",
  components: {
    AdivareSpinner,
    AdivareFlashes,
    AdivareLetterForm,
    AdivareLetterPreview,
    AdivareLetterPrices,
    AdivareLetterDownload,
    AdivareShareWidget,
  },
  emits: [
    'clickGuaranteed',
  ],
  props: {
    twigData: {
      required: true,
      type: Object,
    },
    pdfDownloadUrl: {
      required: true,
      type: String,
    },
    twitterHandle: {
      required: true,
      type: String,
    },
    cloudflareTurnstileSiteKey: {
      required: true,
      type: String,
    },
  },
  computed: {
    ...mapGetters([
      'getActiveCancellation',
      'isGuaranteed',
      'showErrors',
      'getErrorCount',
      'hasValidSignature',
      'getFormFieldValidityStates',
      'getPaymentType',
    ]),
    screenReaderErrorFieldList() {
      if (!this.showErrors) return [];
      let errorArr = [];
      Object.keys(this.getFormFieldValidityStates)
        .filter((item) => !this.getFormFieldValidityStates[item])
        .forEach((key) => {
        errorArr.push(this.$t(`messages_nl.label.${key}`));
      });
      if (!this.getPaymentType.agreeTerms) errorArr.push(this.$t('messages_nl.label.cancellation.conditionCheck'));
      return errorArr;
    },
  },
  data() {
    return {
      mobilePreviewActive: false,
      loading: true,
    }
  },
  created() {
    this.$store.commit('cancellationId', this.twigData.id);
    const initFn = this.twigData.id ? 'setupSpecific' : 'setupGeneric';
    console.debug(`Initializing ${initFn} as initFn`);
    this.$store.dispatch(initFn, this.twigData)
      .then(() => {
        this.loading = false
        this.$store.dispatch('updateSignature');
      })
      .catch((error) => {
          console.error(error);
        }
      );
  },
}
</script>
